import styled from 'styled-components'

import { theme } from '@/styles/theme'

type ListStyle = 'disc' | 'decimal'

export const BulletedList = styled.ul<{ listStyle?: ListStyle }>`
  font-size: 16px;
  line-height: 1.3;
  list-style: ${({ listStyle }) => listStyle ?? 'disc'};
  margin-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 21px;

  > li::marker {
    color: ${({ listStyle }) =>
      listStyle === 'decimal' ? theme.colors.textTitle : theme.colors.grey};
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 1.6;
    gap: 12px;
  }
`
